import { useEffect, useState } from 'react';

const SORT_TABLET_MIN = 561;
const SORT_TABLET_MAX = 680; // 760px - 80px sidebar
const SORT_DESKTOP_MIN = 880;

type ListViewSortBreakpoints = {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
};

const useListViewSortBreakpoints = (): ListViewSortBreakpoints => {
  const [breakpoints, setBreakpoints] = useState<ListViewSortBreakpoints>(() =>
    getBreakpoints(window.innerWidth),
  );

  useEffect(() => {
    const handleResize = () => {
      setBreakpoints(getBreakpoints(window.innerWidth));
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return breakpoints;
};

const getBreakpoints = (width: number): ListViewSortBreakpoints => {
  const isMobile = width < SORT_TABLET_MIN;
  const isTablet = width >= SORT_TABLET_MIN && width <= SORT_TABLET_MAX;
  const isDesktop = width >= SORT_DESKTOP_MIN;
  return {
    isMobile,
    isTablet,
    isDesktop,
  };
};

export {
  SORT_DESKTOP_MIN,
  SORT_TABLET_MAX,
  SORT_TABLET_MIN,
  useListViewSortBreakpoints,
  type ListViewSortBreakpoints,
};
